<template>
  <div
    class="rounded-lg bg-opacity-50 p-2"
    :class="[mode === 'dark' ? 'bg-dark-border' : 'bg-black-10']"
  >
    <div
      class="grid gap-2 sm:grid-cols-1"
      :class="[modeType === 'radio' ? 'grid-cols-3' : 'grid-cols-2']"
    >
      <template v-if="modeType === 'radio'">
        <div
          v-for="option in ['subscribers', 'members', 'both']"
          :key="option"
          class="switcher"
          :class="[mode === 'dark' ? 'dark-switcher' : '']"
        >
          <input
            type="radio"
            :id="option"
            :value="option"
            v-model="radioValue"
            @change="emitRadio"
          />
          <label :for="option">{{ capitalize(option) }}</label>
        </div>
      </template>
      <template v-else>
        <div
          v-for="option in ['assoc_member', 'network_subscriber']"
          :key="option"
          class="switcher"
          :class="[mode === 'dark' ? 'dark-switcher' : '']"
        >
          <input
            type="checkbox"
            :id="option"
            :checked="checkboxValues[option]"
            :disabled="isDisabled"
            @change="(e) => updateCheckbox(option, e.target.checked)"
          />
          <label
            :for="option"
            :class="[isDisabled ? '!cursor-not-allowed' : '']"
            >{{
              capitalize(option === "assoc_member" ? "member" : "subscriber")
            }}</label
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "Switchers",
  props: {
    mode: String,
    modeType: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [Object, String],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkboxValues() {
      return (
        this.modelValue || { assoc_member: false, network_subscriber: false }
      );
    },
    radioValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    updateCheckbox(field, checked) {
      const updated = {
        ...this.checkboxValues,
        [field]: checked,
      };
      this.$emit("update:modelValue", updated);
    },
    emitRadio() {
      this.$emit("update:modelValue", this.radioValue);
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>
